import Tasks from 'APP/Tasks';
import { MyProfilePopup } from 'APP/main/PopupManager/Popups/MyProfilePopup/MyProfilePopup';
import { UserProfilePopup } from 'APP/main/PopupManager/Popups/UserProfilePopup/UserProfilePopup';
import { IUserProfileInitiatorSource } from 'APP/main/Profile/UserProfile/UserProfile.presenter';
import Entities from 'STORE';

interface IUserProfile {
  show(): void;
}

export function useUserProfile(
  userId?: string,
  initiatorSource?: IUserProfileInitiatorSource
): IUserProfile {
  return {
    // TODO: add close popup on parent component destroy
    show(): void {
      if (userId && userId !== Entities.usersStore.Me.id) {
        Tasks.app.openPopup(UserProfilePopup, { params: { userId, initiatorSource } });
      } else {
        Tasks.app.openPopup(MyProfilePopup);
      }
    },
  };
}
